module.exports = __webpack_public_path__ + "img/music-promotion-services-on-websites.4b1a357d.jpg";